import React from "react";

function SayiKumelerininOzellikleri() {
  return <div>SayiKumelerininOzellikleri</div>;
}

export default SayiKumelerininOzellikleri;
